import React from "react";
import { Route, Routes } from "react-router";
import { useSelector } from "react-redux";
import { RootState } from "@reducers/rootReducer";
import { useAuthorization } from "@common/providers";
import { useGetProjectByIdQuery, useWhoAmIQuery } from "@generated";
import ScopeStackSpinner from "@components/ScopeStackSpinner/ScopeStackSpinner";
import useListLocations from "./api/useListLocations";
import useListServiceLocationVariables from "./api/useListProjectVariables";
import Show from "./Show/Show";
import Edit from "./Edit/Edit";
import New from "./New/New";

interface Props {
  project_id: string;
}

const ProjectLocationsV2Mspa: React.FC<Props> = ({ project_id }) => {
  const projectId = project_id;
  const { accountSlug } = useSelector((state: RootState) => state.slug);

  const { data: project, isLoading: projectLoading } =
    useGetProjectByIdQuery({
      id: projectId as any,
      slug: accountSlug,
    });

  const { data: currentUser, isLoading: currentUserLoading } =
    useWhoAmIQuery();

  const { locations, locationsLoading } = useListLocations({ projectId });

  const { variables, variablesLoading } = useListServiceLocationVariables();

  const authorized = useAuthorization();

  if (
    !authorized ||
    projectLoading ||
    currentUserLoading ||
    locationsLoading ||
    variablesLoading ||
    !project ||
    !currentUser
  ) {
    return <ScopeStackSpinner />;
  }

  const projectStatus = project?.data?.attributes?.status || "";
  const privileges = currentUser?.data?.attributes?.privileges || [];
  const permission =
    privileges.find((p) => p.privilege === "projects.locations")?.[
      "access-level"
    ] || "view";

  return (
    <div className="tab-content">
      <div className="tab-pane active">
        <Routes>
          <Route
            path="/"
            element={
              <Show
                projectId={projectId}
                projectStatus={projectStatus}
                permission={permission}
              />
            }
          />
          <Route
            path="/edit/:locationId"
            element={
              <Edit
                projectId={projectId}
                permission={permission}
                projectStatus={projectStatus}
                locations={locations}
                projectVariableDefinitions={variables}
              />
            }
          />
          <Route
            path="/new"
            element={
              <New
                projectId={projectId}
                permission={permission}
                projectStatus={projectStatus}
                locations={locations}
                projectVariableDefinitions={variables}
              />
            }
          />
        </Routes>
      </div>
    </div>
  );
};

export default ProjectLocationsV2Mspa;
